import { DecimalPipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MetaTagsService } from '../shared/services/meta-tags.service';
import { BlogService } from './blog.service';
@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit, OnDestroy {
  blogs: any[] = []
  blogCount: number = 0
  page: number = 1
  take: number = 6
  pageCount: number
  private subs = new Subscription()
  constructor(
    private tsService: Title,
    private metaService: Meta,
    private numberPipe: DecimalPipe,
    private blogService: BlogService,
    private tagsService: MetaTagsService
  ) {
  }

  ngOnInit(): void {
    this.setUpSeo()
    this.searchBlogs()
  }

  setUpSeo() {
    const title = 'IHM Used Parts | Blog'
    this.tsService.setTitle(title)
    const tags = [
      { property: 'og:image', content: `${environment.webUrl}/assets/images/ihm-used-parts-og.png` },
      { property: 'og:title', content: title },
      { property: 'og:type', content: 'website' },
      { property: 'og:description', content: environment.webDescription },
      { property: 'description', content: environment.webDescription }
    ]
    tags.forEach(x => {
      this.metaService.updateTag(x)
    })
    this.tagsService.setCurrentTags(tags)
  }

  searchBlogs() {
    const params = { page: this.page, take: this.take }
    this.subs.add(
      this.blogService.searchBlogs(params).subscribe(data => {
        if (data) {
          if (data.blogs && data.blogs.length) {
            this.blogs = data.blogs
            this.blogCount = data.count
            this.pageCount = Math.ceil(this.blogCount / this.take)
          } else {
            this.blogs = []
            this.blogCount = 0
          }
        }
      })
    )
  }

  previousPage(pageNo: number) {
    if (pageNo && pageNo !== 1) {
      this.page = pageNo - 1
      this.searchBlogs()
    }
  }

  nextPage(pageNo: number) {
    if (pageNo) {
      const div = this.blogCount / this.take
      const dec = Math.ceil(div)
      const lastPage = +dec
      if (pageNo + 1 <= lastPage) {
        this.page = pageNo + 1
        this.page = pageNo + 1
        this.searchBlogs()
      }
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe()
  }

}
